import config from "config/config";
import { useTranslations } from "contexts/LocalizationContext";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import {
  ChakraStack as Stack,
  ChakraDivider as Divider,
  ChakraHeading as Heading,
  ChakraButton as Button,
} from "@airhelp/react-ui-components";
import {
  WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT_UA,
  WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT,
  positiveItems,
  negativeItems,
} from "./config";
import ItemsList from "./ItemsList";
import ListWrapper from "./ListWrapper";
import NegativeItem from "./NegativeItem";
import PositiveItem from "./PositiveItem";

const WhyChooseAHLists = () => {
  const translations = useTranslations();
  const handletrackEvents = () => {
    trackUAEvent(WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT_UA);
    trackCustomEvent(WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT);
  };

  return (
    <Stack
      direction={{ base: "column", md: "row" }}
      spacing={{ base: 8, md: 4, lg: 8 }}
      justify={{ base: "left", md: "center" }}
      align="flex-start"
      maxW={{ base: "full", lg: "936px" }}
    >
      <ListWrapper bg={{ base: "none", md: "greyscale.300" }}>
        <Heading variant="h4" as="h4" mb={{ base: 6, md: 8 }}>
          {translations("why_airhelp_claim_by_yourself")}
        </Heading>
        <Divider mb={8} display={{ base: "none", md: "block" }} />
        <ItemsList>
          {negativeItems.map((item) => (
            <NegativeItem key={item.headingTranslationKey} item={item} />
          ))}
        </ItemsList>
      </ListWrapper>

      <ListWrapper bg={{ base: "none", md: "white" }}>
        <Heading variant="h4" as="h4" mb={{ base: 6, md: 8 }}>
          {translations("why_airhelp_use_airhelp")}
        </Heading>
        <Divider mb={8} display={{ base: "none", md: "block" }} />
        <ItemsList>
          {positiveItems.map((item) => (
            <PositiveItem key={item.headingTranslationKey} item={item} />
          ))}
        </ItemsList>
        <Button mt={8} as="a" href={`${config.funnelUrl}/claims/new/`} onClick={handletrackEvents}>
          {translations("check_compensation")}
        </Button>
      </ListWrapper>
    </Stack>
  );
};

export default WhyChooseAHLists;
